<template>
  <el-card shadow="never" class="portal-eChart-box">
    <div  class="portal-common-title">
      <span>{{ title }}</span>
    </div>
    <div class="eChart-box-body">
      <div class="flex-details" >
        <div class="flex-details-item">
          <img src="@/assets/home/img1.png">
          <div>
            <span>午托学位</span>
            <span>{{data.noonServiceCapacity || 0}}</span>
          </div>
        </div>
        <div class="flex-details-item">

          <img src="@/assets/home/img1.png">
          <div>
            <span>午托学生</span>
            <span>{{data.noonExpectedAttendance || 0}}</span>
          </div>
        </div>
        <div class="flex-details-item">
          <img src="@/assets/home/img2.png">
          <div>
            <span>晚托学位</span>
            <span>{{data.eveningServiceCapacity || 0}}</span>
          </div>
        </div>
        <div class="flex-details-item">
          <img src="@/assets/home/img2.png">
          <div>
            <span>晚托学生</span>
            <span>{{data.eveningExpectedAttendance || 0}}</span>
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import * as echarts from 'echarts'
import resize from '@/components/common/mixins/resize'
import request from '@/config/request.js'
import moment from 'moment'
const ApiHome = request.Home
export default {
  mixins: [resize],
  props: {
    title: { type: String, default: '' },
    option: { type: Object, default: () => {} },
    propsApi: '',
    subTitle: '',
    isSearch:  { type: Boolean, default: false },
  },
  data() {
    return {
      chart: null,
      currOption: {},
      isEmpty: true,
      activeName: 'regionChart',
      value: moment().format('YYYY'),
      data: {}
    }
  },
  created() {
    this.getData()
  },
  mounted () {
  },
  methods: {
    handleChangeData() {
      this.getData()
    },
    getData() {
      ApiHome.getZoneServiceCapacity.call(this, {}, (res => {
        this.data = res || {}
      }))
    },
  },
}
</script>

<style lang="less">
.el-card__body{
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  .portal-common-title{
    padding: 18px 20px;
    box-sizing: border-box;
  }
  .eChart-box-body {
    flex: 1;
    height: 100%;
    .portal-common-noData-eChart{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .flex-details{
      display: flex;
      justify-content: space-evenly;
      width: 100%;
      .flex-details-item{
        img{
          width: 47px;
          height: 47px;
        }
        display: flex;
        // flex-direction: column;
        align-items: center;
        justify-content: center;
        div{
          margin-left: 10px;
          font-size: 14px;
          color: #333333;
          display: flex;
          flex-direction: column;
          span {
            &:nth-child(2){
            color:#409eff;
            margin-top: 3px;
          }
          }
        }
      }
    }
  }
  .dom-canvas{
    height: 100%;
  }
}


</style>
